/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-underscore-dangle */
import { FC, memo } from 'react';
import ButtonLink from '@components/ButtonLink';
import { MDXRemoteSerializeResult } from 'next-mdx-remote';

import * as styles from './styles';

type Props = {
  isModal: boolean;
  internalLink?: string;
  externalLink?: string;
  buttonLabel?: string;
  heading?: string;
  markdownContent?: MDXRemoteSerializeResult;
  handleModal?: (mkdwn: MDXRemoteSerializeResult, heading: string) => void;
  handleEvent?: () => void;
  newTab?: boolean;
};

const ServiceButton: FC<Props> = ({
  isModal = false,
  newTab = false,
  internalLink,
  externalLink,
  heading,
  markdownContent,
  buttonLabel,
  handleModal,
  handleEvent,
}) =>
  buttonLabel ? (
    <>
      {isModal ? (
        <ButtonLink
          className={styles.button}
          noChevron
          onClick={() => handleModal(markdownContent, heading)}
        >
          {buttonLabel}
        </ButtonLink>
      ) : (
        <>
          {internalLink || externalLink ? (
            <ButtonLink
              className={styles.button}
              internalLink={Boolean(internalLink)}
              href={internalLink || externalLink}
              target={Boolean(externalLink) || newTab ? '_blank' : undefined}
              rel={
                Boolean(externalLink) || newTab
                  ? 'noopener noreferrer'
                  : undefined
              }
              noChevron
              onClick={() => handleEvent()}
            >
              {buttonLabel}
            </ButtonLink>
          ) : (
            <p>{buttonLabel}</p>
          )}
        </>
      )}
    </>
  ) : null;

export default memo(ServiceButton);
